import { usergetStorageSync, usersetStorageSync } from '@/common/browser-storage'
/**
 * 全局本地偏好统一入口。
 *
 * 仅保存与服务端业务数据无关、跨 App 重启需要恢复的轻量选择。每个偏好必须
 * 使用独立、带版本号的 key，并在这里完成类型归一化与默认值处理；已发布 key
 * 禁止原地改变类型，不兼容调整必须新增版本 key。
 */
const REGION_NAVIGATION_CATEGORY_KEY = 'regionNavigationCategoryCodeV1'
const HOME_SCENE_EXPANDED_KEY = 'homeSceneExpandedV1'

const readPreference = (key, fallback) => {
  try {
    const value = usergetStorageSync(key)
    return value === undefined || value === null || value === '' ? fallback : value
  } catch (error) {
    console.log('读取本地偏好失败', key, error)
    return fallback
  }
}

const writePreference = (key, value) => {
  try {
    usersetStorageSync(key, value)
  } catch (error) {
    console.log('保存本地偏好失败', key, error)
  }
  return value
}

const toBoolean = (value, fallback) => {
  if (value === true || value === 1 || value === '1' || value === 'true') return true
  if (value === false || value === 0 || value === '0' || value === 'false') return false
  return fallback
}

export const getRegionNavigationCategoryPreference = () => {
  const code = String(readPreference(REGION_NAVIGATION_CATEGORY_KEY, 'all') || '').trim()
  return code || 'all'
}

export const setRegionNavigationCategoryPreference = categoryCode => {
  const code = String(categoryCode || '').trim() || 'all'
  return writePreference(REGION_NAVIGATION_CATEGORY_KEY, code)
}

export const getHomeSceneExpandedPreference = () =>
  toBoolean(readPreference(HOME_SCENE_EXPANDED_KEY, false), false)

export const setHomeSceneExpandedPreference = expanded =>
  writePreference(HOME_SCENE_EXPANDED_KEY, expanded === true)

// 账号级偏好必须显式提供服务地址及用户ID，不使用token作为永久存储键。
export const accountPreferenceKey = (server, user, name) =>
  'accountPreference:v1:' + JSON.stringify([server, String(user), name])
export const getAccountPreference = (server, user, name, fallback) =>
  user ? readPreference(accountPreferenceKey(server, user, name), fallback) : fallback
export const setAccountPreference = (server, user, name, value) => {
  if (user) writePreference(accountPreferenceKey(server, user, name), value)
  return value
}
